import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Car, Map, ClipboardList } from "lucide-react";
import TrackingWidget from "@/components/admin/TrackingWidget";
import TrackingCompareWidget from "@/components/admin/TrackingCompareWidget";

export default function Dashboard() {
  const [stats, setStats] = useState({ vehicles: 0, routes: 0, bookings: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [v, r, b] = await Promise.all([api.get("/vehicles"), api.get("/routes"), api.get("/bookings")]);
        setStats({ vehicles: v.data?.length || 0, routes: r.data?.length || 0, bookings: b.data?.length || 0 });
      } catch { /* ignore */ }
    })();
  }, []);

  const cards = [
    { label: "Vehicles", value: stats.vehicles, icon: Car },
    { label: "Routes", value: stats.routes, icon: Map },
    { label: "Bookings", value: stats.bookings, icon: ClipboardList },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-[#F5F1EB] text-3xl md:text-4xl">Dashboard</h1>
      <p className="text-[#8A8A8A] mt-2 text-sm">Overview of your fleet.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
        {cards.map((c) => (
          <div key={c.label} className="border border-[#2A2A2A] p-6">
            <div className="flex items-center justify-between">
              <div className="text-overline text-[#C9A55A]">{c.label}</div>
              <c.icon className="text-[#C9A55A]" size={18}/>
            </div>
            <div className="font-display text-[#F5F1EB] text-4xl mt-3">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <TrackingWidget />
      </div>
      <div className="mt-6">
        <TrackingCompareWidget />
      </div>
    </div>
  );
}
